"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gsap_1 = require("gsap");
const THREE = __importStar(require("three"));
const Chapter_1 = __importDefault(require("./Chapter"));
const Cliff_1 = __importDefault(require("../three/element/Cliff"));
const Text_1 = __importDefault(require("../three/element/Text"));
class ChapterDirection extends Chapter_1.default {
    constructor(stage, text, key) {
        super();
        this.text = text;
        this.key = key;
        this.stage = stage;
        this.cliff = null;
        this.txtKo = null;
    }
    start() {
        this.stage.renderer.setClearColor(0x000000, 1);
        this.stage.scene.fog = new THREE.Fog(0x000000, 0, 1);
        this.stage.camera.position.set(0, 0, 2);
        this.stage.controls.target.set(0, 0, 0);
        this.stage.controls.update();
        this.stage.grid.setWhite();
        this.stage.fixCameraBasePos();
        this.cliff = new Cliff_1.default();
        this.cliff.rotation.x = -1.2;
        this.stage.add(this.cliff);
        this.txtKo = new Text_1.default(0.8, 0.2, this.stage.cache.get('textDirection'), true);
        this.txtKo.position.set(-0.6, 0.4, -1);
        this.stage.add(this.txtKo);
        this._animate();
        this.dispatchTextWhite();
        this.done(6, new THREE.Vector3(0, 0, 0));
    }
    update(time) {
        var _a;
        (_a = this.cliff) === null || _a === void 0 ? void 0 : _a.update();
    }
    stop(cb) {
        var _a, _b;
        (_a = this.txtKo) === null || _a === void 0 ? void 0 : _a.fadeOut(0.4);
        gsap_1.gsap.to(this.stage.scene.fog, {
            duration: 1,
            near: 0,
            far: 0,
            ease: 'power2.inOut',
        });
        (_b = this.cliff) === null || _b === void 0 ? void 0 : _b.hide(() => {
            if (this.cliff)
                this.stage.remove(this.cliff);
            if (this.txtKo)
                this.stage.remove(this.txtKo);
            this.cliff = null;
            this.txtKo = null;
            cb();
        });
    }
    _animate() {
        var _a;
        (_a = this.cliff) === null || _a === void 0 ? void 0 : _a.draw();
        gsap_1.gsap.to(this.stage.scene.fog, {
            duration: 5,
            near: 8,
            far: 15,
            ease: 'power2.inOut',
        });
        gsap_1.gsap.delayedCall(4, () => {
            var _a;
            (_a = this.txtKo) === null || _a === void 0 ? void 0 : _a.fadeIn(3);
            this.showText(0, 'white');
        });
    }
}
exports.default = ChapterDirection;
